'use client';
import { cn } from '@/app/utils';
import type { ActiveTabType, EditionType } from './Payment';

interface PaymentTabsProps {
  tabs: { key: ActiveTabType; label: string; onClick: () => void }[];
  activeTab: ActiveTabType;
  /** 不传 / 空数组时不渲染版本切换器（团队空间被锁定为 team edition 即不显示） */
  editionOptions?: { key: EditionType; label: string }[];
  edition?: EditionType;
  onEditionChange?: (key: EditionType) => void;
}

export const PaymentTabs = ({ tabs, activeTab, editionOptions, edition, onEditionChange }: PaymentTabsProps) => {
  const showEditionSwitcher = editionOptions && editionOptions.length > 0;

  return (
    <div className="mt-5 flex items-center justify-between border-system-white08 border-b px-4 sm:flex-col sm:items-stretch sm:gap-3 sm:border-b-0 sm:px-4">
      <div className="flex items-center sm:w-full sm:justify-between">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <div
              key={tab.key}
              className={cn(
                'relative cursor-pointer px-6 py-4 text-base text-white transition-opacity',
                isActive ? 'font-semibold' : 'font-normal opacity-[0.64] hover:opacity-[0.88]',
              )}
              onClick={tab.onClick}
            >
              {tab.label}
              {isActive && <div className="-bottom-px absolute inset-x-0 h-0.5 bg-white" />}
            </div>
          );
        })}
      </div>
      {showEditionSwitcher && (
        <div className="flex items-center rounded-[12px] bg-system-white08 ring-1 ring-system-white08 sm:self-end">
          {editionOptions.map((opt) => {
            const isActive = edition === opt.key;
            return (
              <button
                key={opt.key}
                type="button"
                onClick={() => onEditionChange?.(opt.key)}
                className={cn(
                  'flex min-w-[100px] items-center justify-center rounded-12 px-4 py-2 text-sm text-white transition-colors',
                  isActive
                    ? 'border border-system-white16 bg-system-white12 font-medium'
                    : 'border border-transparent font-normal opacity-[0.64] hover:opacity-[0.88]',
                )}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
